export class AppError{
    constructor(public originalError?:any){

    }
}


// WEBPACK FOOTER //
// D:/Projects/Veepal/Veepal.Com/Dev/src/app/common/app-error.ts